<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div
    *ngIf="
      aircraftProfileEngineAudits && aircraftProfileEngineAudits.length > 0;
      else noAircraftProfileEngineAudits
    "
  >
    Aircraft - Engine Relationship
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="aircraftProfileEngineAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAircraftProfileEngineAudits> No Aircraft - Engine audits </ng-template>

  <div *ngIf="engineAudits && engineAudits.length > 0; else noEngineAudits">
    Engine
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="engineAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noEngineAudits> No Engine audits </ng-template>
</ng-template>
